export const messages = {
    en: {
        buildingManage: {
            search: {
                title: 'Search Conditions',
                name: 'Please enter building name',
                salesStatus: 'Sales Status',
                houseType: 'House Type'
            },
            list: {
                title: 'Building List'
            },
            table: {
                id: 'Building ID',
                name: 'Building Name',
                intro: 'Introduction',
                unitPrice: 'Unit Price',
                totalPrice: 'Total Price',
                salesStatus: 'Sales Status',
                houseType: 'House Type'
            },
            add: {
                title: 'Add Building',
                name: 'Building Name',
                namePlaceholder: 'Required, please enter building name',
                intro: 'Introduction',
                introPlaceholder: 'Please enter building introduction',
                tags: 'Tags',
                tagsPlaceholder: 'Please enter tags',
                unitPrice: 'Unit Price',
                unitPricePlaceholder: 'Please enter unit price',
                coverImg: 'Cover Image',
                coverImgPlaceholder: 'Please upload cover image',
                headerImg: 'Header Image',
                headerImgPlaceholder: 'Please upload header image',
                totalPrice: 'Total Price',
                totalPricePlaceholder: 'Please enter total price',
                discountInfo: 'Discount Info',
                discountInfoPlaceholder: 'Please enter discount information',
                salesStatus: 'Sales Status',
                salesStatusPlaceholder: 'Please select sales status',
                houseType: 'House Type',
                houseTypePlaceholder: 'Please select house type',
                buildingType: 'Building Type',
                buildingTypePlaceholder: 'Please enter building type',
                propertyRight: 'Property Right',
                propertyRightPlaceholder: 'Please enter property right',
                buildingDesc: 'Building Description',
                buildingDescPlaceholder: 'Please enter building description',
                houseInfo: 'House Information',
                houseNamePlaceholder: 'Please enter house name',
                houseSizePlaceholder: 'Please enter house size',
                houseStatePlaceholder: 'Please enter house state',
                housePricePlaceholder: 'Please enter house price',
                addHouse: 'Add House Type',
                houseInfoPlaceholder: 'Please enter house information',
                salesInfo: 'Sales Information',
                saleNamePlaceholder: 'Please enter sales name',
                saleJobPlaceholder: 'Please enter sales job',
                saleTelPlaceholder: 'Please enter sales telephone',
                addSale: 'Add Sales Person',
                salesInfoPlaceholder: 'Please enter sales information',
                features: 'Features',
                featuresPlaceholder: 'Please enter building features',
                lat: 'Latitude',
                latPlaceholder: 'Please enter latitude',
                lng: 'Longitude',
                lngPlaceholder: 'Please enter longitude',
                address: 'Address',
                addressPlaceholder: 'Please enter address'
            },
            edit: {
                title: 'Edit Building',
                name: 'Building Name',
                namePlaceholder: 'Required, please enter building name',
                intro: 'Introduction',
                introPlaceholder: 'Please enter building introduction',
                tags: 'Tags',
                tagsPlaceholder: 'Please enter tags',
                unitPrice: 'Unit Price',
                unitPricePlaceholder: 'Please enter unit price',
                coverImg: 'Cover Image',
                coverImgPlaceholder: 'Please upload cover image',
                headerImg: 'Header Image',
                headerImgPlaceholder: 'Please upload header image',
                totalPrice: 'Total Price',
                totalPricePlaceholder: 'Please enter total price',
                discountInfo: 'Discount Info',
                discountInfoPlaceholder: 'Please enter discount information',
                salesStatus: 'Sales Status',
                salesStatusPlaceholder: 'Please select sales status',
                houseType: 'House Type',
                houseTypePlaceholder: 'Please select house type',
                buildingType: 'Building Type',
                buildingTypePlaceholder: 'Please enter building type',
                propertyRight: 'Property Right',
                propertyRightPlaceholder: 'Please enter property right',
                buildingDesc: 'Building Description',
                buildingDescPlaceholder: 'Please enter building description',
                houseInfo: 'House Information',
                houseInfoPlaceholder: 'Please enter house information',
                salesInfo: 'Sales Information',
                saleNamePlaceholder: 'Please enter sales name',
                saleJobPlaceholder: 'Please enter sales job',
                saleTelPlaceholder: 'Please enter sales telephone',
                addSale: 'Add Sales Person',
                salesInfoPlaceholder: 'Please enter sales information',
                features: 'Features',
                featuresPlaceholder: 'Please enter building features',
                lat: 'Latitude',
                latPlaceholder: 'Please enter latitude',
                lng: 'Longitude',
                lngPlaceholder: 'Please enter longitude',
                address: 'Address',
                addressPlaceholder: 'Please enter address'
            },
            delete: {
                title: 'Confirm Operation',
                confirmText: 'Are you sure to delete this building?'
            },
            validate: {
                nameRequired: 'Building name is required',
                nameMaxLength: 'Building name cannot exceed 100 characters',
                introMaxLength: 'Introduction cannot exceed 100 characters',
                tagsMaxLength: 'Tags cannot exceed 100 characters',
                unitPriceMaxLength: 'Unit price cannot exceed 50 characters',
                coverImgMaxLength: 'Cover image URL cannot exceed 255 characters',
                headerImgMaxLength: 'Header image URL cannot exceed 255 characters',
                totalPriceMaxLength: 'Total price cannot exceed 255 characters',
                discountInfoMaxLength: 'Discount information cannot exceed 255 characters',
                salesStatusRequired: 'Sales status is required',
                salesStatusMaxLength: 'Sales status cannot exceed 50 characters',
                houseTypeMaxLength: 'House type cannot exceed 100 characters',
                buildingTypeMaxLength: 'Building type cannot exceed 255 characters',
                propertyRightMaxLength: 'Property right cannot exceed 255 characters',
                addressMaxLength: 'Address cannot exceed 255 characters',
                latMaxLength: 'Latitude cannot exceed 20 characters',
                lngMaxLength: 'Longitude cannot exceed 20 characters',
                saleNameRequired: 'Sales name is required',
                saleJobRequired: 'Sales job is required',
                saleTelRequired: 'Sales telephone is required',
                houseImgRequired: 'House image is required',
                houseNameRequired: 'House name is required',
                houseSizeRequired: 'House size is required',
                houseStateRequired: 'House state is required',
            },
            salesStatusOptions: {
                toBeSold: 'To Be Sold',
                onSale: 'On Sale',
                soldOut: 'Sold Out'
            },
            houseTypeOptions: {
                apartment: 'Apartment',
                villa: 'Villa'
            }
        }
    },
    zh: {
        buildingManage: {
            search: {
                title: '查询条件',
                name: '请输入楼盘名称',
                salesStatus: '销售状态',
                houseType: '房屋类型'
            },
            list: {
                title: '楼盘列表'
            },
            table: {
                id: '楼盘ID',
                name: '楼盘名称',
                intro: '楼盘简介',
                unitPrice: '单价',
                totalPrice: '总价',
                salesStatus: '销售状态',
                houseType: '房屋类型'
            },
            add: {
                title: '添加楼盘',
                name: '楼盘名称',
                namePlaceholder: '必填，请输入楼盘名称',
                intro: '楼盘简介',
                introPlaceholder: '请输入楼盘简介',
                tags: '楼盘标签',
                tagsPlaceholder: '请输入楼盘标签',
                unitPrice: '单价',
                unitPricePlaceholder: '请输入单价',
                coverImg: '封面图片',
                coverImgPlaceholder: '请上传封面图片',
                headerImg: '头部图片',
                headerImgPlaceholder: '请上传头部图片',
                totalPrice: '总价',
                totalPricePlaceholder: '请输入总价',
                discountInfo: '优惠信息',
                discountInfoPlaceholder: '请输入优惠信息',
                salesStatus: '销售状态',
                salesStatusPlaceholder: '请选择销售状态',
                houseType: '房屋类型',
                houseTypePlaceholder: '请选择房屋类型',
                buildingType: '建筑类型',
                buildingTypePlaceholder: '请输入建筑类型',
                propertyRight: '产权年限',
                propertyRightPlaceholder: '请输入产权年限',
                buildingDesc: '楼盘介绍',
                buildingDescPlaceholder: '请输入楼盘介绍',
                houseInfo: '房型介绍',
                houseNamePlaceholder: '房型名称',
                houseSizePlaceholder: '房型面积',
                houseStatePlaceholder: '房型状态',
                housePricePlaceholder: '房型价格',
                addHouse: '添加房型',
                houseInfoPlaceholder: '请输入房型介绍',
                salesInfo: '销售介绍',
                saleNamePlaceholder: '请输入销售姓名',
                saleJobPlaceholder: '请输入销售职位',
                saleTelPlaceholder: '请输入销售电话',
                addSale: '添加销售人员',
                salesInfoPlaceholder: '请输入销售介绍',
                features: '楼盘特点',
                featuresPlaceholder: '请输入楼盘特点',
                lat: '纬度',
                latPlaceholder: '请输入纬度',
                lng: '经度',
                lngPlaceholder: '请输入经度',
                address: '地址',
                addressPlaceholder: '请输入地址'
            },
            edit: {
                title: '编辑楼盘',
                name: '楼盘名称',
                namePlaceholder: '必填，请输入楼盘名称',
                intro: '楼盘简介',
                introPlaceholder: '请输入楼盘简介',
                tags: '楼盘标签',
                tagsPlaceholder: '请输入楼盘标签',
                unitPrice: '单价',
                unitPricePlaceholder: '请输入单价',
                coverImg: '封面图片',
                coverImgPlaceholder: '请上传封面图片',
                headerImg: '头部图片',
                headerImgPlaceholder: '请上传头部图片',
                totalPrice: '总价',
                totalPricePlaceholder: '请输入总价',
                discountInfo: '优惠信息',
                discountInfoPlaceholder: '请输入优惠信息',
                salesStatus: '销售状态',
                salesStatusPlaceholder: '请选择销售状态',
                houseType: '房屋类型',
                houseTypePlaceholder: '请选择房屋类型',
                buildingType: '建筑类型',
                buildingTypePlaceholder: '请输入建筑类型',
                propertyRight: '产权年限',
                propertyRightPlaceholder: '请输入产权年限',
                buildingDesc: '楼盘介绍',
                buildingDescPlaceholder: '请输入楼盘介绍',
                houseInfo: '房型介绍',
                houseNamePlaceholder: '房型名称',
                houseSizePlaceholder: '房型面积',
                houseStatePlaceholder: '房型状态',
                housePricePlaceholder: '房型价格',
                addHouse: '添加房型',
                houseInfoPlaceholder: '请输入房型介绍',
                salesInfo: '销售介绍',
                saleNamePlaceholder: '请输入销售姓名',
                saleJobPlaceholder: '请输入销售职位',
                saleTelPlaceholder: '请输入销售电话',
                addSale: '添加销售人员',
                salesInfoPlaceholder: '请输入销售介绍',
                features: '楼盘特点',
                featuresPlaceholder: '请输入楼盘特点',
                lat: '纬度',
                latPlaceholder: '请输入纬度',
                lng: '经度',
                lngPlaceholder: '请输入经度',
                address: '地址',
                addressPlaceholder: '请输入地址'
            },
            delete: {
                title: '确认操作',
                confirmText: '确认删除该楼盘吗？'
            },
            validate: {
                nameRequired: '楼盘名称不能为空',
                nameMaxLength: '楼盘名称不能超过100个字符',
                introMaxLength: '楼盘简介不能超过100个字符',
                tagsMaxLength: '楼盘标签不能超过100个字符',
                unitPriceMaxLength: '单价不能超过50个字符',
                coverImgMaxLength: '封面图片URL不能超过255个字符',
                headerImgMaxLength: '头部图片URL不能超过255个字符',
                totalPriceMaxLength: '总价不能超过255个字符',
                discountInfoMaxLength: '优惠信息不能超过255个字符',
                salesStatusRequired: '销售状态不能为空',
                salesStatusMaxLength: '销售状态不能超过50个字符',
                houseTypeMaxLength: '房屋类型不能超过100个字符',
                buildingTypeMaxLength: '建筑类型不能超过255个字符',
                propertyRightMaxLength: '产权年限不能超过255个字符',
                addressMaxLength: '地址不能超过255个字符',
                latMaxLength: '纬度不能超过20个字符',
                lngMaxLength: '经度不能超过20个字符',
                saleNameRequired: '销售姓名不能为空',
                saleJobRequired: '销售职位不能为空',
                saleTelRequired: '销售电话不能为空',
                houseImgRequired: '房型图片不能为空',
                houseNameRequired: '房型名称不能为空',
                houseSizeRequired: '房型面积不能为空',
                houseStateRequired: '房型状态不能为空',
            },
            salesStatusOptions: {
                toBeSold: '待售',
                onSale: '在售',
                soldOut: '售罄'
            },
            houseTypeOptions: {
                apartment: '公寓',
                villa: '别墅'
            }
        }
    }
}